import { render, staticRenderFns } from "./hallDetail.vue?vue&type=template&id=984fabd4&scoped=true"
import script from "./hallDetail.vue?vue&type=script&lang=js"
export * from "./hallDetail.vue?vue&type=script&lang=js"
import style0 from "./hallDetail.vue?vue&type=style&index=0&id=984fabd4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984fabd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('984fabd4')) {
      api.createRecord('984fabd4', component.options)
    } else {
      api.reload('984fabd4', component.options)
    }
    module.hot.accept("./hallDetail.vue?vue&type=template&id=984fabd4&scoped=true", function () {
      api.rerender('984fabd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/mechanism/hallDetail.vue"
export default component.exports